import React, { Fragment, useState } from 'react';

const Slider = ({ filtro }) => {
  const [info, setInfo] = useState(filtro);
  const { name, image } = info[0]

  return (
    <Fragment>
      <div className="slider" id="description">
        <div className="slider__brand">
          <img src={image} alt={name} />
        </div>
        <div className="slider__name">

          <h1 className="display-1 title__focus text-white animate__animated animate__pulse animate__slower animate__infinite" >{name}</h1>
        </div>
      </div>
    </Fragment>
  );
}

export default Slider;
